import { IContactClient, IContactClientForm } from '../types'
import { map } from 'lodash'

export const contactToForm = (contact: IContactClient): IContactClientForm => ({
  ...contact,
  customFields: map(contact.customFields, (value, key) => ({ key, value })),
})



// WEBPACK FOOTER //
// src/features/Contacts/utils/contactToForm.ts